import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import * as actions from './redux/actions';
import { withNamespaces } from 'react-i18next';

import Header from './Header';
import Footer from './Footer';
import Interstitial from './Interstitial';
import InterstitialLoader from './InterstitialLoader';
import elpPathService from '../../common/elpPathService';

export class AppContainer extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { common, t } = this.props;

    const { tenant, requestGetTenantPending, requestGetTenantError, supportedBrowserVersions  } = common;
    const { name, logoUrl, displayName, supportEmail, websiteUrl, supportPhone, mspTenantId } = tenant;

    const isPending = (isEmpty(tenant) || requestGetTenantPending);
    const hasErrors = requestGetTenantError;
    const showLoader = isPending && !hasErrors;
    
    if(showLoader) {
      return (
        <InterstitialLoader />
      );
    }

    if(hasErrors){
      return (
        <Interstitial>
          <div className="usa-alert usa-alert--error" role="alert">
            <div className="usa-alert__body">
              <h3 className="usa-alert__heading">Error</h3>
              <p className="usa-alert__text">{t('network_error.message')}</p>
            </div>
          </div>
        </Interstitial>
      );
    }
    
    return (
      <div>
        <a className="usa-skipnav" href="#search-input">Skip to main content</a>
        <Header logoUrl={logoUrl} websiteUrl={websiteUrl} agencyLoginUrl={elpPathService.getAgencyLoginPath(mspTenantId)} tenantName={name} supportedBrowserVersions={supportedBrowserVersions} />
        { this.props.children }
        <Footer 
          agencyName={displayName}
          phoneNumber={supportPhone}
          email={supportEmail}
          website={websiteUrl}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces(['common'])(AppContainer));



// WEBPACK FOOTER //
// ./src/features/common/AppContainer.js